module.exports = __webpack_public_path__ + "static/media/laptop.c591ab23.png";